import React from 'react';
import {View, Sync} from 'MWC';
import tpl from '../../templates/newreports/new.reports.jsx';
import errorTpl from '../../templates/newreports/error.jsx';
import {apiback} from 'config';
import widgetsHelper from 'utils/getWidget.helper';
import {canUseDOM} from '../../../../helpers/canUseDOM';
import {filterTreeByEnvironment} from '../../../../helpers/utils/environmentFilter';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: errorTpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INTERACTIVE,
            collection: [],
            loader: true,
            uiHasError: false,
            where_by: ['path'],
            search_by: ['/about/reports'],
            widgets: []
        };
        this.widgetsHelper = widgetsHelper;

        return this;
    }

    componentWillMount() {
        if (canUseDOM) return;
        const {ssrData} = this.props;
        if (ssrData && ssrData.widgets && ssrData.widgets.length > 0) {
            this.setState({widgets: ssrData.widgets, loader: false});
        }
    }

    componentDidMount() {
        this.load();
        if (!this.state.widgets.length) {
            this.widgetsHelper.getWidgets.call(this);
        }
    }

    componentReady() {
        if (this.state.uiHasError) {
            this.setState({ui: this.uiStates.ERROR});
        }
    }

    openDoc = async report => {
        if (report.url) {
            return window.open(report.link);
        }
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_LINKS') + '/' + report.shp_id,
            xhr = new Engine({
                url: url,
                type: 'GET',
                dataType: 'json',
                cache: false,
                mode: 'cors'
            });

        try {
            const response = await xhr.get();
            window.open(response.data);
        } catch (error) {
            this.setState({
                uiHasError: true
            });
            return error;
        }
    };

    load = async () => {
        const Engine = Sync.getEngine('xhr');

        const xhr = new Engine({
            url: apiback('API_REPORTS'),
            type: 'GET',
            dataType: 'json',
            cache: false,
            mode: 'cors'
        });

        try {
            const response = await xhr.get();
            const data = filterTreeByEnvironment(response.data);
            this.setState({
                collection: [...data].sort((a, b) => Number(b.position) - Number(a.position)),
                loader: false
            });
        } catch (error) {
            this.setState({
                uiHasError: true
            });
            return error;
        }
    };

    static displayName = 'About.Views.NewReport';
}
